<template>
  <div class="px-4">
    <div>
      <p v-if="panelUser">
        Dla wybranego użytkownika znaleziono profil w {{ paLabel }} o tym samym
        numerze telefonu.
      </p>

      <p v-else>
        Dla wybranego użytkownika nie znaleziono profilu w {{ paLabel }}.
      </p>
      <profile-preview
        v-if="panelUser"
        :name="`${panelUser.firstName} ${panelUser.lastName}`"
        :phone="`${panelUser.phone}`"
      />
      <p class="mt-4"><b>Co zrobić Sir?</b></p>
      <div class="checkboxes">
        <div class="checkbox">
          <input
            type="radio"
            :id="`createNewProfile-${panelSegment}`"
            :name="`createNewOrUpdateProfile-${panelSegment}`"
            v-model="createNewOrUpdateProfile"
            value="NEW"
          />
          <label class="mt-2 ml-2" :for="`createNewProfile-${panelSegment}`"
            >Utwórz nowy profil w {{ paLabel }}</label
          >
        </div>
        <div class="checkbox" v-if="panelUser">
          <input
            type="radio"
            :id="`updateProfile-${panelSegment}`"
            :name="`createNewOrUpdateProfile-${panelSegment}`"
            value="UPDATE"
            v-model="createNewOrUpdateProfile"
          />
          <label class="mt-2 ml-2" :for="`updateProfile-${panelSegment}`"
            >Połącz profile {{ paLabel }} i SeniorApp</label
          >
        </div>
      </div>
      <div class="modal-buttons">
        <custom-button
          @click="closeVerifyPwzModal()"
          :size="'small'"
          :title="'NIE'"
          :gray="true"
          :customStyles="'width: 50%'"
        />
        <custom-button
          @click="confirmAcceptServicePwz()"
          :size="'small'"
          :title="'TAK'"
          :gradient="true"
          :customStyles="'width: 50%'"
        />
      </div>
    </div>
  </div>
</template>

<script>
import CustomButton from "./CustomButton.vue";
import ProfilePreview from "./ProfilePreview.vue";
import axios from "../axios";
import { PANELS } from "../config/panels";

// Jeden komponent dla obu instancji panelu opiekunow: prop `panel` (DOD|POD) wybiera
// backendowy segment glownej aplikacji (dod/* vs pod/*), akcje store i etykiety PA.
export default {
  components: { ProfilePreview, CustomButton },
  props: {
    phone: { type: String, required: true },
    selectedUserService: { type: Object, default: null },
    panel: { type: String, default: PANELS.DOD },
  },
  name: "VerifyPwzDodModal",
  data() {
    return {
      createNewOrUpdateProfile: "NEW",
    };
  },
  watch: {
    phone() {
      this.fetchPanelUser();
    },
  },
  async mounted() {
    await this.fetchPanelUser();
  },
  methods: {
    async fetchPanelUser() {
      await this.$store.dispatch(this.fetchActionName, { phone: this.phone });
    },
    closeVerifyPwzModal() {
      document.getElementById(`${this.modalId}-close`).click();
    },

    async confirmAcceptServicePwz() {
      const item = this.selectedUserService;
      await axios.put(`/api/userService/${item.id}/pwz/accept`);

      if (this.panelUser && this.createNewOrUpdateProfile === "UPDATE") {
        await axios.put(
          `/api/${this.panelSegment}/users/phone/${this.phone}/set${this.panelIdSegment}UserId`,
          {
            id: this.panelUser.id,
          }
        );
      }
      if (this.createNewOrUpdateProfile === "NEW") {
        await axios.post(
          `/api/${this.panelSegment}/users/phone/${this.phone}/createUser`,
          {}
        );
      }
      await this.fetchPanelUser();
      this.$notify({
        group: "success",
        text: "Pomyślnie zweryfikowano usługę",
      });
      this.$emit("servicesUpdated");
      this.closeVerifyPwzModal();
    },
  },
  computed: {
    isPod() {
      return this.panel === PANELS.POD;
    },
    panelSegment() {
      return this.isPod ? "pod" : "dod";
    },
    panelIdSegment() {
      return this.isPod ? "Pod" : "Dod";
    },
    paLabel() {
      return this.isPod ? "PA POD" : "PA DOD";
    },
    modalId() {
      return `verify-pwz-${this.panelSegment}-modal`;
    },
    fetchActionName() {
      return this.isPod ? "getPodUserByPhoneNumber" : "getDodUserByPhoneNumber";
    },
    panelUser() {
      return this.isPod
        ? this.$store.getters.getPodUser
        : this.$store.getters.getDodUser;
    },
  },
};
</script>
<style scoped>
.checkbox {
  display: flex;
  align-items: center;
}
div {
  padding-left: 0px;
}
.modal-buttons {
  display: flex;
  gap: 10px;
  justify-content: center;
}
</style>
